import { render, staticRenderFns } from "./Prodotti.vue?vue&type=template&id=7c194ace&"
import script from "./Prodotti.vue?vue&type=script&lang=js&"
export * from "./Prodotti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports